import { render } from "./index.vue?vue&type=template&id=4f7df5d0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4f7df5d0&lang=scss&scoped=true"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7df5d0"]])

export default __exports__